import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const CopyNote = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M16 21v1.88A1.1 1.1 0 0 1 14.87 24H2.13c-.32 0-.58-.1-.8-.33a1.09 1.09 0 0 1-.33-.8V5.63a1.1 1.1 0 0 1 1.13-1.12H5.5v13.88c0 .71.25 1.34.75 1.87.53.5 1.16.75 1.88.75H16Zm0-16.13c0 .32.1.58.33.8.22.22.48.33.8.33H22v12.38a1.1 1.1 0 0 1-1.13 1.12H8.13c-.3 0-.57-.1-.8-.33a1.09 1.09 0 0 1-.32-.8V1.13A1.1 1.1 0 0 1 8.14.01H16v4.88Zm5.67-1.45c.22.22.33.49.33.8v.28h-4.5V0h.28c.31 0 .58.1.8.33l3.1 3.1Z" />
    </SvgIcon>
);
